import {
  faCircle,
  faCircleDot as faRegularCircleDot,
  faDotCircle as faRegularDotCircle,
  faSquare,
  faStar as faRegularStar
} from "@fortawesome/pro-regular-svg-icons";
import {
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowsAltV,
  faArrowUp,
  faBackspace,
  faBackwardStep,
  faBars,
  faCalendar,
  faCalendarAlt,
  faCaretDown,
  faCaretRight,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle as faSolidCircle,
  faCircleDot,
  faCloudUploadAlt,
  faCompress,
  faDotCircle,
  faEdit,
  faExclamation,
  faExclamationTriangle,
  faEyeDropper,
  faForwardStep,
  faInfoCircle,
  faKeyboard,
  faMinus,
  faMinusSquare,
  faPalette,
  faPaperclip,
  faPause,
  faPencil,
  faPlay,
  faPlus,
  faReply,
  faSort,
  faSortDown,
  faSortUp,
  faSquareCheck,
  faSquareMinus,
  faStar,
  faStarHalf,
  faStarHalfAlt,
  faStepBackward,
  faStepForward,
  faSync,
  faTimes,
  faTimesCircle,
  faTriangleExclamation,
  faUpload,
  faVolumeHigh,
  faVolumeLow,
  faVolumeOff
} from "@fortawesome/pro-solid-svg-icons";
import type { IconAliases } from "vuetify";

const icons = [
  faChevronUp,
  faCheck,
  faTimesCircle,
  faTimes,
  faCheckCircle,
  faInfoCircle,
  faExclamation,
  faExclamationTriangle,
  faChevronLeft,
  faChevronRight,
  faCheckSquare,
  faMinusSquare,
  faSolidCircle,
  faArrowUp,
  faArrowDown,
  faChevronDown,
  faBars,
  faCaretDown,
  faDotCircle,
  faEdit,
  faStar,
  faStarHalf,
  faSync,
  faStepBackward,
  faStepForward,
  faArrowsAltV,
  faPaperclip,
  faPlus,
  faMinus,
  faCalendar,
  faCaretRight,
  faEyeDropper,
  faCloudUploadAlt,
  faPalette,
  faKeyboard,
  faReply,
  faArrowLeft,
  faArrowRight,
  faBackspace,
  faPlay,
  faPause,
  faCompress,
  faVolumeHigh,
  faVolumeLow,
  faVolumeOff,
  faSort,
  faSortUp,
  faSortDown,
  faSquareCheck,
  faSquareMinus,
  faStarHalfAlt,
  faUpload,
  faCalendarAlt,
  faCircleDot,
  faTriangleExclamation,
  faPencil,
  faBackwardStep,
  faForwardStep,
  faSquare,
  faCircle,
  faRegularDotCircle,
  faRegularStar,
  faRegularCircleDot
];

const aliases: IconAliases = {
  collapse: "fas fa-chevron-up",
  complete: "fas fa-check",
  cancel: "far fa-xmark",
  close: "far fa-xmark",
  delete: "fas fa-xmark",
  clear: "fas fa-xmark",
  success: "fas fa-check-circle",
  info: "fas fa-info-circle",
  warning: "fas fa-exclamation",
  error: "fas fa-triangle-exclamation",
  prev: "fas fa-chevron-left",
  next: "fas fa-chevron-right",
  checkboxOn: "fas fa-square-check",
  checkboxOff: "far fa-square",
  checkboxIndeterminate: "fas fa-square-minus",
  delimiter: "fas fa-circle",
  sort: "fas fa-sort",
  sortAsc: "fas fa-sort-up",
  sortDesc: "fas fa-sort-down",
  expand: "fas fa-chevron-down",
  menu: "fas fa-bars",
  subgroup: "fas fa-caret-down",
  dropdown: "fas fa-caret-down",
  radioOn: "far fa-circle-dot",
  radioOff: "far fa-circle",
  edit: "fas fa-pencil",
  ratingEmpty: "fas fa-star",
  ratingFull: "fas fa-star",
  ratingHalf: "fas fa-star-half",
  loading: "fas fa-sync",
  first: "fas fa-backward-step",
  last: "fas fa-forward-step",
  unfold: "fas fa-arrows-alt-v",
  file: "fas fa-paperclip",
  plus: "fas fa-plus",
  minus: "fas fa-minus",
  calendar: "fas fa-calendar-alt",
  treeviewCollapse: "fas fa-chevron-up",
  treeviewExpand: "fas fa-chevron-down",
  eyeDropper: "fas fa-eye-dropper",
  upload: "fas fa-upload",
  color: "fas fa-palette",
  command: "fas fa-keyboard",
  ctrl: "fas fa-keyboard",
  shift: "fas fa-arrow-up",
  alt: "fas fa-keyboard",
  space: "fas fa-square",
  enter: "fas fa-reply",
  arrowup: "fas fa-arrow-up",
  arrowdown: "fas fa-arrow-down",
  arrowleft: "fas fa-arrow-left",
  arrowright: "fas fa-arrow-right",
  backspace: "fas fa-backspace",
  play: "fas fa-play",
  pause: "fas fa-pause",
  fullscreen: "fas fa-fullscreen",
  fullscreenExit: "fas fa-compress",
  volumeHigh: "fas fa-volume-high",
  volumeMedium: "fas fa-volume-low",
  volumeLow: "fas fa-volume-off",
  volumeOff: "fas fa-volume-off",
  tableGroupCollapse: "fas fa-chevron-down",
  tableGroupExpand: "fas fa-chevron-right"
};

export default {
  aliases,
  icons
};
